export default {
    nematodeTest: null,
  };
  